// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3xufq","text":"SelectPayment_text__2DVqE","title":"SelectPayment_title__1alwI","btn":"SelectPayment_btn__3byEQ"};